export default "__VITE_ASSET__CBd2TaTG__"